import { environment } from '../utils/environment';

class Progressbar {
  constructor(progressBar) {
    this.element = progressBar;
    this.progressEndpoint = progressBar.dataset.endpoint;
    this.progressFigure = progressBar.dataset.progressfigure;
    this.progressLimit = progressBar.querySelector('.js-progressLimit');
    this.progressNumber = progressBar.querySelector('.progressbar__progressNumber');
    this.progressCurrentNumbers = progressBar.querySelectorAll('.js-progressCurrentNumber');
    this.progressBar = progressBar.querySelector('.progressbar__progressBar');
    this.progressWrapper = progressBar.querySelector('.progressbar__progressWrapper');
    this.progressTooltip = progressBar.querySelector('.progressbar__progressTooltip');
    this.shareBtn = progressBar.querySelector('.progressbar__shareBtn');
    this.shareBox = progressBar.querySelector('.progressbar__shareBox');
    this.progressSpinner = progressBar.querySelector('.progressbar__spinner');
    this.progressContent = progressBar.querySelector('.progressbar__content');
    this.overLimit = progressBar.querySelector('.progressbar__progressNumber--overLimitLine');

    if (this.progressEndpoint) {
      this.fetchEndpoint();
    } else if (this.progressFigure) {
      this.displayPercentage(parseInt(this.progressFigure, 10));
    } else {
      console.error('No progress figure at this time');
    }

    if (this.shareBtn) {
      this.shareBtn.addEventListener('click', (event) => this.openShare(event));
    }

    this.closeShare = (event) => {
      if (!event.target.closest('.progressbar__shareBox')) {
        this.shareBox.style.display = 'none';
        window.removeEventListener('click', this.closeShare, false);
      }
    };
  }

  fetchEndpoint() {
    fetch(this.progressEndpoint, {
      headers: { 'X-Environment': environment() },
    })
      .then((response) => response.json())
      .then(({ enrollments }) => this.displayPercentage(enrollments));
  }

  displayPercentage(number) {
    const progressLimit = parseInt(this.progressLimit.dataset.progresslimit, 10);
    this.progressContent.style.display = 'block';
    this.progressSpinner.style.display = 'none';
    const percentageValue = (number / progressLimit) * 100;

    this.progressTooltip.style.display = 'block';
    this.progressTooltip.innerHTML = Math.round(percentageValue) + '%';
    this.progressCurrentNumbers.forEach((progressCurrentNumber) => (progressCurrentNumber.innerHTML = number));

    if (percentageValue <= 100) {
      this.progressWrapper.style.width = percentageValue + '%';
    }

    if (percentageValue > 100) {
      this.element.classList.add('progressbar--overLimit');
      this.overLimit.style.left = (progressLimit / number) * 100 + '%';
    }
  }

  openShare(event) {
    event.stopPropagation();
    if (this.shareBox.style.display == 'block') {
      this.shareBox.style.display = 'none';
      this.shareBtn.blur();
      return;
    }
    this.shareBox.style.display = 'block';

    window.addEventListener('click', this.closeShare);
  }
}

function init() {
  [...document.querySelectorAll('.js-progressbar')].forEach((el) => new Progressbar(el));
}

export { init };
